import { useTranslation } from "next-i18next";
import { IKeyFigureGroup, ITags } from "src/api/server/extended-search";
import { PopularFiltersContent } from "src/components/pages/search/components/popular-filters/components/popular-filters-content";
import { NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS } from "src/components/pages/search/constants";
import { usePopularFiltersCounter } from "src/components/pages/search/hooks/use-popular-filters-counter";
import { ISearch } from "src/components/pages/search/search.types";
import { FilterCategoryItem } from "../filter-category-item";

interface IPopularFilters extends ISearch {
    popularKeyFiguresGroup: IKeyFigureGroup;
    tagsData: ITags;
}

export const PopularFilters = ({ popularKeyFiguresGroup, tagsData, onSearch }: IPopularFilters) => {
    const { t } = useTranslation("extended-search");

    const numberOfSelectedFilters = usePopularFiltersCounter();

    const { basics, tradings, rewards, investmentHorizon, investmentRegion, alphaBeta } = tagsData;
    const numberOfPopularFilters =
        popularKeyFiguresGroup.keyFigures.length +
        basics.tags.length +
        tradings.tags.length +
        rewards.tags.length +
        investmentHorizon.tags.length +
        investmentRegion.tags.length +
        alphaBeta.tags.length +
        NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS;

    return (
        <FilterCategoryItem title={t("labels.popular-filters")} badgeInfo={`${numberOfSelectedFilters} / ${numberOfPopularFilters}`}>
            <PopularFiltersContent popularKeyFiguresGroup={popularKeyFiguresGroup} tagsData={tagsData} onSearch={onSearch} />
        </FilterCategoryItem>
    );
};
